export const round = (number: string | number, defimalPlaces = 2) => {
  if (typeof number === 'string') number = parseFloat(number);

  return parseFloat(number.toFixed(defimalPlaces));
}